import { useQuery } from '@tanstack/react-query';
import request from 'utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import deserializeDateFromServer from 'utils/time/deserializeDateFromServer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import parseISO from 'utils/time/parseISO';

function getDaysWithEvents({
  schoolyearId,
  schoolId,
  tz,
}: {
  schoolyearId: string;
  schoolId: string;
  tz: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/cahier-journal/days-with-events`;
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: any[] }) =>
    data.map(d => deserializeDateFromServer(parseISO(d), tz)),
  );
}

export const CAHIER_JOURNAL_DAYS_WITH_EVENTS_KEY = 'days-with-events';

interface Props {
  schoolyearId?: string;
  schoolId?: string;
}

export function useGetDaysWithEvents(props?: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const schoolyearId = props?.schoolyearId || schoolyear.id;
  const user = useUser();
  const schoolId = props?.schoolId || school.id;
  return useQuery({
    queryKey: [schoolyearId, schoolId, CAHIER_JOURNAL_DAYS_WITH_EVENTS_KEY],
    queryFn: () =>
      getDaysWithEvents({
        schoolyearId: schoolyearId,
        schoolId: schoolId,
        tz: user.location,
      }),

    enabled: !!schoolyearId && !!schoolId,
    refetchOnWindowFocus: false,

    // 30 mins
    staleTime: 30 * (60 * 1000),

    // 35 mins
    gcTime: 35 * (60 * 1000),
  });
}
